import fetch from 'auth/FetchInterceptor'

const NoteService = {
  getAll: (params = null) =>
    fetch({ url: '/crm/notes', method: 'get', params }),
  create: (data) => fetch({ url: '/crm/notes', method: 'post', data }),
  update: (id, data) =>
    fetch({ url: `/crm/notes/${id}`, method: 'patch', data }),
  remove: (id) => fetch({ url: `/crm/notes/${id}`, method: 'delete' }),
}

export default NoteService
